import { Button, HStack, Text } from '@ui-furniture/elements';
import { ExtendComponent } from '@ui-furniture/style/types/extend-component';
import { ArrowToggle } from '@ui-furniture/ui/arrow-toggle';

export const ExpandButton: ExtendComponent<
  typeof Button & {
    expandDirection: 'up' | 'down';
    isCollapsed: boolean;
    toggleCollapse: () => void;
    text?: string;
  }
> = ({
  text,
  expandDirection,
  toggleCollapse,
  isCollapsed,
  size,
  strokeWidth,
  ...props
}) => (
  <Button
    type='button'
    variant='blank'
    w='100%'
    textAlign='center'
    color={{ _: 'brand-text', hover: 'brand-orange' } as any}
    onClick={toggleCollapse}
    {...props}
  >
    <HStack justifyContent='center' alignItems='center'>
      <ArrowToggle
        initialDir={expandDirection === 'up' ? 'up' : 'down'}
        isToggled={!isCollapsed}
        size={size}
        strokeWidth={strokeWidth}
      />

      {text && (
        <Text fontSize='sm' color='inherit' position='relative' top='1px'>
          {text}
        </Text>
      )}
    </HStack>
  </Button>
);
